module.exports = __webpack_public_path__ + "img/cerrar-sesion-white.7ef9a2d4.svg";